import getPathSRP from '@/utilities/getPathSRP';

export default function withVDPExpired() {
    return async (ctx, next) => {

        const {
            expired_vdp_immediate_redirect: [enableExpiredVdpImmediateRedirect],
        } = ctx.useFeatures([
            'expired_vdp_immediate_redirect',
        ]);

        // Case 1: If the VDP returns no results, redirect the user to the SRP.
        // Case 2: If the user navigates to the VDP via the SRP, and the VDP LSC fails to retrieve data (ctx.res is undefined), display the VDP with limited information from the SRP response and an alert message.
        if (enableExpiredVdpImmediateRedirect && ctx?.res && (!ctx?.data?.totalResultCount || ctx?.data?.totalResultCount === 0)) {
            const statusCode = 301;
            const query = { ...ctx.query };
            delete query.referrer;
            delete query.clickType;
            delete query.listingId;

            const srpPath = await getPathSRP(query, { brand: ctx.data.brand });

            ctx.res.cookie('redirectExpiredPage', 1);

            ctx.res.redirect(statusCode, srpPath);
            ctx.res.end();

            ctx.statusCode = statusCode;
            next('server redirect');
        }
    };
}
